/**
 * 对接人（Proxy）角色常量
 * 与 Spatie 角色名、公司创建时 seed 的角色一致
 */
export const PROXY_ROLE_NAME = '对接人'

/** 对接人 / Grant 登录后的默认落地：活动列表（受邀工作台） */
export const PROXY_DEFAULT_HOME = '/dashboard/conference/events'
